export default __webpack_public_path__ + "static/media/ISO.8e21dee8.png";